__turbopack_context__.v({
  "root": "styles-module-scss-module__Is4-DG__root",
  "title": "styles-module-scss-module__Is4-DG__title",
});
